function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" {...props}><text transform="translate(-5 -5)" fill="#323232" fillRule="evenodd" fontFamily="AppleColorEmoji, Apple Color Emoji" fontSize="16"><tspan x="5" y="22">🕒</tspan></text></svg>;
});